import { List, ListItem, ListItemText } from '@mui/material';
import { formatJordan, type Device } from '@serb/shared';
import { Panel } from '../../components/Panel';

export function DevicesPanel({ devices }: { devices: Device[] }) {
  return (
    <Panel title="Your devices" subtitle="Devices that can open this app with Face ID / Touch ID.">
      <List dense disablePadding>
        {devices.map((d) => (
          <ListItem key={d.name + d.added} divider disableGutters>
            <ListItemText primary={d.name} secondary={'last used ' + formatJordan(d.lastUsed ?? d.added)} />
          </ListItem>
        ))}
      </List>
    </Panel>
  );
}
